import { ReactComponent as BudgetIcon } from "images/icons/budget.svg";
import { ReactComponent as CalendarIcon } from "images/icons/calendar.svg";
import { ReactComponent as ChairIcon } from "images/icons/chair.svg";
import { ReactComponent as CitySizeIcon } from "images/icons/city-size.svg";
import { ReactComponent as CityIcon } from "images/icons/city.svg";
import { ReactComponent as CloudyIcon } from "images/icons/cloudy.svg";
import { ReactComponent as RainyDayIcon } from "images/icons/rainy-day.svg";
import { ReactComponent as CompanionIcon } from "images/icons/companion.svg";
import { ReactComponent as HikerIcon } from "images/icons/hiker.svg";
import { ReactComponent as LandscapeIcon } from "images/icons/landscape.svg";
import { ReactComponent as MoonIcon } from "images/icons/moon.svg";
import { ReactComponent as PalmIcon } from "images/icons/palm.svg";
import { ReactComponent as PlaceIcon } from "images/icons/place.svg";
import { ReactComponent as PrecipitationIcon } from "images/icons/precipitation.svg";
import { ReactComponent as SeaTempIcon } from "images/icons/sea_temp.svg";
import { ReactComponent as ShellIcon } from "images/icons/shell.svg";
import { ReactComponent as SunIcon } from "images/icons/sun.svg";
import { ReactComponent as SwimmingIcon } from "images/icons/swimming.svg";
import { ReactComponent as WitnessIcon } from "images/icons/witness.svg";
import { ReactComponent as HomeIcon } from "images/icons/home.svg";
import { ReactComponent as SunsetIcon } from "images/icons/sunset.svg";
import { ReactComponent as NatureIcon } from "images/icons/nature.svg";
import { ReactComponent as FilterIcon } from "images/icons/filter.svg";
import { ReactComponent as ClearIcon } from "images/icons/close_cross.svg";
import Close from "@mui/icons-material/Close";

export const icons = {
    "prices.pricesOverall": [BudgetIcon, true],
    focus: [ChairIcon, false],
    continent: [PlaceIcon, false],
    suitability: [CompanionIcon, false],
    month: [CalendarIcon, false],
    "weather.sst": [SeaTempIcon, false],
    "weather.tmax": [SunIcon, false],
    "weather.tmin": [MoonIcon, false],
    "weather.wet": [PrecipitationIcon, false],
    "weather.season": [CloudyIcon, false],
    beachSports: [SwimmingIcon, false],
    beachType: [ShellIcon, false],
    beachAmenities: [PalmIcon, false],
    natureSports: [HikerIcon, false],
    natureLandscapes: [LandscapeIcon, false],
    natureActivities: [WitnessIcon, false],
    "other.citySize": [CitySizeIcon, false],
    cityAttractions: [WitnessIcon, false],
    essentials: [HomeIcon, false],
    weather: [RainyDayIcon, false],
    beach: [SunsetIcon, true],
    nature: [NatureIcon, true],
    city: [CityIcon, false],
    prices: [BudgetIcon, true],
    other: [FilterIcon, true],
    clear: [ClearIcon, false]
};
